<!-- Mobile Top Bar (only visible on mobile) -->
@if (isMobile()) {
<mat-toolbar class="mobile-top-bar">
    <button mat-icon-button (click)="toggleMenu()" class="menu-toggle-btn" [attr.aria-label]="'Abrir menú' | translate">
        <mat-icon class="mobile-menu-icon">menu</mat-icon>
    </button>
    <span class="spacer"></span>
    <img class="logo" [ngSrc]="logoUrl()" [alt]="'Logo MyServy' | translate" width="152" height="31" priority>
</mat-toolbar>
}

<!-- Mobile Drawer Backdrop -->
@if (isMobile() && menuOpen()) {
<div class="mobile-drawer-backdrop" (click)="toggleMenu()"></div>
}

<!-- Navigation Drawer / Rail Container -->
<div class="drawer-container" [class.is-rail]="isRail()" [class.mobile-open]="isMobile() && menuOpen()">

    <header>
        <button (click)="toggleMenu()" class="menu-toggle-btn filled"
            [attr.aria-label]="(isRail() ? 'Abrir menú' : 'Cerrar menú') | translate">
            <mat-icon>
                {{ isMobile() ? 'menu_open' : (isRail() ? 'menu' : 'menu_open') }}
            </mat-icon>
        </button>

        <!-- El logo mide 152px y el riel 92: acá solo entra el botón de crear.
             Cuando el rol no puede crear actividades el hueco queda vacío, que es
             mejor que meter el logo recortado. -->
        @if (isRail()) {
            @if (puede('actividades:crear')) {
            <button class="menu-create-btn filled" routerLink="/activities/create"
                [attr.aria-label]="'Crear actividad' | translate">
                <mat-icon>add</mat-icon>
            </button>
            }
        } @else {
        <img class="logo" [ngSrc]="logoUrl()" [alt]="'Logo MyServy' | translate" width="152" height="31" priority>
        }
    </header>

    @if (!isRail() && puede('actividades:crear')) {
    <div class="create-btn-container">
        <button mat-flat-button class="create-btn label-large" routerLink="/activities/create"
            [attr.aria-label]="'Crear actividad' | translate">
            <mat-icon>add</mat-icon>
            <span class="btn-text">{{ 'Crear actividad' | translate }}</span>
        </button>
    </div>
    }

    <div class="header-divider"></div>

    <div class="scroll-content">
        <nav class="nav-list">
            @if (puede('panel:ver')) {
            <a class="nav-item" matRipple routerLink="/dashboard" routerLinkActive="active-link"
                [attr.aria-label]="'Panel Principal' | translate">
                <mat-icon class="nav-icon">dashboard</mat-icon>
                <span class="nav-label" [class.rail-hidden]="isRail()">{{ 'Panel Principal' | translate }}</span>
            </a>
            }
            @if (puede('actividades:ver')) {
            <a class="nav-item" matRipple routerLink="/activities" routerLinkActive="active-link"
                [attr.aria-label]="'Actividades' | translate">
                <mat-icon class="nav-icon">task_alt</mat-icon>
                <span class="nav-label" [class.rail-hidden]="isRail()">{{ 'Actividades' | translate }}</span>
            </a>
            }
            @if (puede('activos:ver')) {
            <a class="nav-item" matRipple routerLink="/assets" routerLinkActive="active-link"
                [attr.aria-label]="'Activos' | translate">
                <mat-icon class="nav-icon">widgets</mat-icon>
                <span class="nav-label" [class.rail-hidden]="isRail()">{{ 'Activos' | translate }}</span>
            </a>
            }
            @if (puede('planes:ver')) {
            <a class="nav-item" matRipple routerLink="/schedules" routerLinkActive="active-link"
                [attr.aria-label]="'Planes Preventivos' | translate">
                <mat-icon class="nav-icon">edit_calendar</mat-icon>
                <span class="nav-label" [class.rail-hidden]="isRail()">{{ 'Planes Preventivos' | translate }}</span>
            </a>
            }
            @if (puede('checklists:ver')) {
            <a class="nav-item" matRipple routerLink="/checklists" routerLinkActive="active-link"
                [attr.aria-label]="'Listas de verificación' | translate">
                <mat-icon class="nav-icon">checklist</mat-icon>
                <span class="nav-label" [class.rail-hidden]="isRail()">{{ 'Listas de verificación' | translate }}</span>
            </a>
            }
            @if (puede('equipo:ver')) {
            <a class="nav-item" matRipple routerLink="/users" routerLinkActive="active-link"
                [attr.aria-label]="'Miembros' | translate">
                <mat-icon class="nav-icon">person</mat-icon>
                <span class="nav-label" [class.rail-hidden]="isRail()">{{ 'Miembros' | translate }}</span>
            </a>
            }
            @if (puede('unidades:ver')) {
            <a class="nav-item" matRipple routerLink="/work-units" routerLinkActive="active-link"
                [attr.aria-label]="'Unidades de trabajo' | translate">
                <mat-icon class="nav-icon">groups</mat-icon>
                <span class="nav-label" [class.rail-hidden]="isRail()">{{ 'Unidades de trabajo' | translate }}</span>
            </a>
            }
            @if (puede('sedes:ver')) {
            <a class="nav-item" matRipple routerLink="/branches" routerLinkActive="active-link"
                [attr.aria-label]="'Sedes' | translate">
                <mat-icon class="nav-icon">corporate_fare</mat-icon>
                <span class="nav-label" [class.rail-hidden]="isRail()">{{ 'Sedes' | translate }}</span>
            </a>
            }
            @if (puede('reportes:ver')) {
            <a class="nav-item" matRipple routerLink="/reports" routerLinkActive="active-link"
                [attr.aria-label]="'Reportes' | translate">
                <mat-icon class="nav-icon">leaderboard</mat-icon>
                <span class="nav-label" [class.rail-hidden]="isRail()">{{ 'Reportes' | translate }}</span>
            </a>
            }

            <!-- Van con el resto de la lista también en el riel. Colgados del pie
                 quedaban al fondo del sidebar, lejos del grupo al que pertenecen,
                 y el menú cambiaba de forma al plegarse. -->
            <div class="menu-divider"></div>

            <!-- Notificaciones queda fuera del menú por ahora: la ruta
                 /notifications no existe, así que el enlace rebotaba al panel
                 sin decir nada. Se reactiva cuando exista la pantalla. -->
            <!--
            <a class="nav-item" matRipple routerLink="/notifications" routerLinkActive="active-link"
                [attr.aria-label]="'Notificaciones' | translate">
                <mat-icon class="nav-icon">notifications</mat-icon>
                <span class="nav-label" [class.rail-hidden]="isRail()">{{ 'Notificaciones' | translate }}</span>
            </a>
            -->
            <!-- Abre el cambio de solucion en vez de navegar: el destino vive en
                 otra aplicacion, no en una ruta de esta. Sigue siendo el mismo
                 enlace de siempre; role y tabindex lo mantienen alcanzable con
                 el teclado ahora que no lleva href. -->
            @if (muestraCambioDeSolucion()) {
            <a class="nav-item" matRipple role="button" tabindex="0" (click)="abrirCambioDeSolucion()"
                (keydown.enter)="abrirCambioDeSolucion()"
                (keydown.space)="abrirCambioDeSolucion(); $event.preventDefault()"
                [attr.aria-label]="'Soluciones' | translate">
                <mat-icon class="nav-icon">apps</mat-icon>
                <span class="nav-label" [class.rail-hidden]="isRail()">{{ 'Soluciones' | translate }}</span>
            </a>
            }
        </nav>
    </div>

    <footer>
        <div class="footer-divider"></div>

        <!-- Pie de perfil con su propio popup: el menú se ancla al drawer y sube,
             en vez de flotar en un overlay, para que acompañe al rail. -->
        <div class="nav-footer" [class.profile-menu-open]="menuPerfilAbierto()">

            @if (menuPerfilAbierto()) {
            <div class="inline-menu profile-menu-popup" (click)="$event.stopPropagation()">

                <!-- Decía "Perfil" con ícono de persona, pero lo que hace es
                     alternar el tema. El texto nombra el tema al que se va a
                     cambiar, que es lo que pasa al tocarlo. -->
                <button type="button" class="inline-menu-item" (click)="theme.toggleTheme()">
                    <mat-icon class="inline-icon">{{ theme.isDarkMode() ? 'light_mode' : 'dark_mode' }}</mat-icon>
                    <span>{{ (theme.isDarkMode() ? 'Tema claro' : 'Tema oscuro') | translate }}</span>
                </button>

                <button type="button" class="inline-menu-item" (click)="alternarSubmenuIdioma()"
                    [attr.aria-expanded]="submenuIdiomaAbierto()">
                    <mat-icon class="inline-icon">language</mat-icon>
                    <span>{{ 'Idioma' | translate }}</span>
                    <mat-icon class="chevron">
                        {{ submenuIdiomaAbierto() ? 'expand_more' : 'chevron_right' }}
                    </mat-icon>
                </button>

                @if (submenuIdiomaAbierto()) {
                <div class="language-submenu">
                    @for (lang of availableLanguages; track lang.code) {
                    <button type="button" class="inline-menu-item sub-item" (click)="setLanguage(lang.code)"
                        [class.active]="currentLang() === lang.code" [disabled]="currentLang() === lang.code">
                        <mat-icon class="inline-icon">
                            {{ currentLang() === lang.code ? 'check_circle' : 'translate' }}
                        </mat-icon>
                        <span>{{ lang.label }}</span>
                    </button>
                    }
                </div>
                }

                <div class="divider-horizontal"></div>

                <!-- Siempre se ve el workspace activo; el de cambiar sólo si hay a dónde. -->
                <div class="workspace-actual" role="presentation">
                    <mat-icon class="inline-icon">domain</mat-icon>
                    <div class="workspace-actual-textos">
                        <span class="label-small text-secondary">{{ 'Workspace' | translate }}</span>
                        <span class="body-small weight-bold">{{ nombreWorkspaceActivo() }}</span>
                    </div>
                </div>

                @if (hasMultipleWorkspaces()) {
                <button type="button" class="inline-menu-item" (click)="abrirCambioDeWorkspace()">
                    <mat-icon class="inline-icon">swap_horiz</mat-icon>
                    <span>{{ 'Cambiar de workspace' | translate }}</span>
                </button>
                }

                <div class="divider-horizontal"></div>

                <button type="button" class="inline-menu-item" (click)="cerrarSesion()">
                    <mat-icon class="inline-icon">logout</mat-icon>
                    <span>{{ 'Cerrar sesión' | translate }}</span>
                </button>
            </div>
            }

            <!-- role y tabindex: es un div, así que sin esto no era alcanzable con
                 el teclado y aria-expanded no estaba permitido sobre un div. -->
            <div class="footer-content" role="button" tabindex="0" (click)="alternarMenuPerfil($event)"
                (keydown.enter)="alternarMenuPerfil($event); $event.preventDefault()"
                (keydown.space)="alternarMenuPerfil($event); $event.preventDefault()"
                [attr.aria-expanded]="menuPerfilAbierto()" [attr.aria-label]="'Perfil de usuario' | translate">
                <div class="user-avatar-container">
                    <div class="user-avatar">
                        <img [ngSrc]="avatarUrl()" [alt]="'Avatar de usuario' | translate" class="avatar-img"
                            width="40" height="40">
                    </div>
                </div>
                <div class="user-info" [class.rail-hidden]="isRail()">
                    <span class="user-name">{{ userName() }}</span>
                    <span class="user-role">{{ userRole() }}</span>
                </div>
                <mat-icon class="footer-chevron" [class.rotated]="menuPerfilAbierto()"
                    [class.rail-hidden]="isRail()">keyboard_arrow_right</mat-icon>
            </div>
        </div>
    </footer>
</div>
